document.addEventListener('DOMContentLoaded', function() {
  setDateTimePickerListener();
  toggleOrganizationRemitTo();
  toggleBillingAddress();
});

function setDateTimePickerListener() {
  document.querySelectorAll('input.datetimepicker').flatpickr({
    allowInput: true,
    enableTime: true,
    dateFormat: 'h:i K m/d/Y',
    minuteIncrement: 15
  });
  document.querySelectorAll('input.datepicker').flatpickr({
    allowInput: true,
    dateFormat: 'm/d/Y'
  });
  document.querySelectorAll('input.timepicker').flatpickr({
    enableDate: false,
    enableTime: true,
    format: 'h:i K',
    minuteIncrement: 15
  });
}

function toggleOrganizationRemitTo() {
  if ( document.querySelector('input#use_organization_address') != null ) {
    const useOrganizationAddressCheckbox = document.querySelector('input#use_organization_address');
    useOrganizationAddressCheckbox.addEventListener('click', function() {
      const organization_id = document.querySelector('select#trial_organization_id').value;
      const remit_to_name = document.querySelector('input#trial_remit_to_name');
      const remit_to_street = document.querySelector('input#trial_remit_to_street');
      const remit_to_city = document.querySelector('input#trial_remit_to_city');
      const remit_to_state = document.querySelector('input#trial_remit_to_state');
      const remit_to_zip = document.querySelector('input#trial_remit_to_zip');
      if (useOrganizationAddressCheckbox.checked) {
        if (organization_id.length > 0) {
          const url = '/admin/organizations/' + organization_id + '/remit_to';
          fetch(url, { dataType: 'json' })
            .then(response => {
              if (response.ok) {
                return response.json();
              }
            })
            .then(data => {
              remit_to_name.setAttribute('value', data.name);
              remit_to_street.setAttribute('value', data.street);
              remit_to_city.setAttribute('value', data.city);
              remit_to_state.setAttribute('value', data.state);
              remit_to_zip.setAttribute('value', data.zip);
            })
            .catch(error => {
              alert('Unable to retrieve Remit To values');
            });
        }
      } else {
        remit_to_name.setAttribute('value', '');
        remit_to_street.setAttribute('value', '');
        remit_to_city.setAttribute('value', '');
        remit_to_state.setAttribute('value', '');
        remit_to_zip.setAttribute('value', '');
      }
    });
  }
}

function toggleBillingAddress() {
  if ( document.querySelector('#billing-information-same-as-account') != null ) {
    const billingAddressCheckbox = document.querySelector('#billing-information-same-as-account');
    billingAddressCheckbox.addEventListener('click', function() {
      const blankBillingFields = document.querySelector('#unpopulated-billing-information');
      const populatedBillingFields = document.querySelector('#populated-billing-information');
      if (billingAddressCheckbox.checked) {
        blankBillingFields.setAttribute('style', 'display: none;');
        populatedBillingFields.setAttribute('style', '');
      } else {
        blankBillingFields.setAttribute('style', '');
        populatedBillingFields.setAttribute('style', 'display: none;');
      }
    });
  }
}
